import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/login-icon.png';

const _withScopeId = n => (_pushScopeId("data-v-d8f82fb0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "header-right"
};
const _hoisted_4 = {
  class: "login-box"
};
const _hoisted_5 = ["src"];

const _hoisted_6 = /*#__PURE__*/_createTextVNode("退出");

const _hoisted_7 = ["href"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "login-icon",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "登录", -1));

const _hoisted_10 = [_hoisted_8, _hoisted_9];
import { getStorage } from '@/plugins/store';
import { getCookie } from '@/plugins/utils';
export default {
  setup(__props) {
    const $http = inject('$http');
    const projectInfo = getStorage('projectBaseData'); // 获取用户信息

    const userInfo = ref();

    const getUserInfo = async () => {
      const token = getCookie('X-Access-Token');
      if (!token) return;
      const res = await $http.getUserInfo();
      console.log('🤪 res >>:', res);
      userInfo.value = res;
    };

    getUserInfo();

    const handleLogout = async () => {
      await $http.logout();
      window.location.href = 'https://id.cpu.edu.cn/sso/logout?service=https://cpu.zhihuishu.com/';
    };

    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("img", {
        class: "logo",
        src: _unref(projectInfo).home_logo_url,
        alt: ""
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [userInfo.value ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        trigger: "hover"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: handleLogout
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          class: "login-icon",
          src: userInfo.value.avatar || require('@/assets/images/login-icon.png'),
          alt: ""
        }, null, 8, _hoisted_5), _createElementVNode("span", null, _toDisplayString(userInfo.value.realname), 1)])]),
        _: 1
      })) : (_openBlock(), _createElementBlock("a", {
        key: 1,
        class: "login-box",
        href: _unref(projectInfo).sso_login_url
      }, _hoisted_10, 8, _hoisted_7))])]);
    };
  }

};